module.exports = __webpack_public_path__ + "img/downloads-pdf.3236b0c1.svg";